export const config = {
  apiKey: "AIzaSyDz7C8jSe3NaVkTqbPemO5FMuHeofV-ePc",
  authDomain: "whtbrd-c459a.firebaseapp.com",
  databaseURL: "https://whtbrd-c459a.firebaseio.com",
  projectId: "whtbrd-c459a",
  storageBucket: "whtbrd-c459a.appspot.com",
  messagingSenderId: "358692504306"
}


// WEBPACK FOOTER //
// ./src/config/firebaseConfig.js